/*
 * lph-ship-date.js – live dispatch date in the product page's shipping pill (snippets/lph-pdp-ship-date.liquid,
 * markup .labk__ship with [data-shipdate]). Same rules as the former delivery pill and the homepage countdown,
 * through window.ldDeliveryCalc (assets/ld-delivery-estimate.js, loaded before this file):
 * order day = today before the cut-off (Europe/Paris) on a business day, otherwise the next business day;
 * then data-days business days (weekends, French public holidays and data-closed days skipped).
 * Short French format « ven. 9 oct. » (just the number, also on the 1st: owner, 30 Sep 2026), full date for screen readers.
 * If anything is missing, the server-rendered date (which already includes a safety margin) stays.
 */
(function () {
  'use strict';

  if (window.lphShipDateReady) return;
  window.lphShipDateReady = true;

  var WD_SHORT = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var WD_LONG = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MO_SHORT = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var MO_LONG = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];

  function toInt(value, fallback, min, max) {
    var n = parseInt(value, 10);
    if (isNaN(n)) n = fallback;
    if (n < min) n = min;
    if (n > max) n = max;
    return n;
  }

  function label(date, weekdays, months) {
    var day = date.getUTCDate();
    return weekdays[date.getUTCDay()] + ' ' + day + ' ' + months[date.getUTCMonth()];
  }

  function shipDate(el, calc) {
    var days = toInt(el.getAttribute('data-days'), 2, 0, 20);
    var cutoff = toInt(el.getAttribute('data-cutoff'), 14, 0, 24);
    var tz = el.getAttribute('data-tz') || 'Europe/Paris';
    var closed = calc.parseExcluded(el.getAttribute('data-closed'));

    function isWorkday(d) {
      var dow = d.getUTCDay();
      if (dow === 0 || dow === 6) return false;
      var key = calc.isoKey(d);
      if (closed[key]) return false;
      return !calc.frenchHolidays(d.getUTCFullYear())[key];
    }
    function nextWorkday(d) {
      for (var i = 0; i < 400; i++) {
        d = calc.addDays(d, 1);
        if (isWorkday(d)) return d;
      }
      return null;
    }

    var now = calc.nowInZone(tz);
    var ship = now.date;
    if (!isWorkday(ship) || now.hour >= cutoff) ship = nextWorkday(ship);
    for (var n = 0; n < days && ship; n++) ship = nextWorkday(ship);
    return ship;
  }

  function update() {
    var calc = window.ldDeliveryCalc;
    if (!calc) return;
    var pills = document.querySelectorAll('[data-lph-ship]');
    for (var p = 0; p < pills.length; p++) {
      var el = pills[p];
      var target = el.querySelector('[data-shipdate]');
      if (!target) continue;
      var ship;
      try {
        ship = shipDate(el, calc);
      } catch (e) {
        ship = null;
      }
      if (!ship) continue;
      var shortLabel = label(ship, WD_SHORT, MO_SHORT);
      if (target.textContent !== shortLabel) target.textContent = shortLabel;
      el.setAttribute('data-ship-iso', calc.isoKey(ship));
      var longTarget = el.querySelector('[data-shipdate-long]');
      if (longTarget) longTarget.textContent = label(ship, WD_LONG, MO_LONG);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  // A tab reopened later (after the cut-off, the next morning) gets the current date.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') update();
  });
  // Theme editor: the product section is re-rendered after each change.
  document.addEventListener('shopify:section:load', update);
})();
